import React from 'react';
import { graphql, Link } from "gatsby"
import { GatsbyImage, getImage } from "gatsby-plugin-image"

export default function PostPreview({post}) {
	
  return (
	  <article className="post-preview">
		<Link to={post.link}>
		  {
			post.featuredImage?.node
			? <GatsbyImage image={getImage(post.featuredImage.node.localFile)} alt={post.title} />
			: null
		  }

		  <div className="content">
			  {
				post.categories?.nodes?.length
				? <p className="categories">{Array.prototype.map.call(post.categories.nodes, function(item) { return item.name; }).join(", ")}</p>
				: null
			  }					
			  <h3>{post.title}</h3>
			  <p className="date">{post.date}</p>
		  </div>
		</Link>
	  </article>
  );
}

export const PostFragment = graphql`
	fragment PostFragment on WpPost {
	  categories {
        nodes {
          name
        }
      }
      title
      link
      date(formatString: "D MMMM YYYY")
      featuredImage {
        node {
          localFile {
		    childImageSharp {
	          gatsbyImageData(
				sizes: "(min-width: 1280px) 405px, (min-width: 768px) 360px, calc(100vw - 64)",
				breakpoints: [622, 720, 810, 1232]
	          )
	        }
          }
        }
      }
	}
`